export enum MortgageStatus {
  HasMortgage = "HAS_MORTGAGE",
  NoMortgage = "NO_MORTGAGE",
  WantsMortgage = "WANTS_MORTGAGE",
  Unknown = "UNKNOWN",
}
